const RESIZE_METHODS = {
  FILL: 'fill',
  FIT: 'fit',
  FULL: 'full',
  VIDEO: 'video',
} as const;

export default RESIZE_METHODS;
